export const LogoMark = ({ size = 44, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect x="2" y="2" width="60" height="60" rx="14" fill="#14284B" />
    <rect x="7.5" y="7.5" width="49" height="49" rx="10" fill="none" stroke="#B8913A" strokeWidth="1.6" />
    <text x="32" y="41.5" fontFamily="Georgia, 'Times New Roman', serif" fontSize="24" fontWeight="600" fill="#F8F5EE" textAnchor="middle">LS</text>
  </svg>
);

export const Logo = ({ dark = false, icon = "", name = "Loan Salaah", sub = true }) => (
  <span className="flex items-center gap-3">
    {icon ? (
      <img src={icon} alt="" className="h-10 w-10 rounded-xl object-cover" />
    ) : (
      <LogoMark size={40} />
    )}
    <span className="leading-none">
      <span className={`block font-serif text-2xl font-semibold tracking-tight ${dark ? "text-ivory" : "text-concordia"}`}>
        {name}
      </span>
      {sub && (
        <span className={`mt-1 block text-[0.58rem] font-medium uppercase tracking-[0.3em] ${dark ? "text-brass" : "text-brass-deep"}`}>
          DSA · Loan Marketplace
        </span>
      )}
    </span>
  </span>
);
